export default __webpack_public_path__ + "static/media/fa-duotone-900.7b41b6c3.woff2";